import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    marginBottom: indent,
  },
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    marginBottom: indent,
  },
  loadingBoxDate: {
    height: indent,
    width: indent * 10,
  },
  bonusProgressBarSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: indent,
  },
  loadingBoxProgressBar: {
    height: 60,
    width: 300,
    marginBottom: indent * 0.4,
  },
  loadingBoxProgressBarMoneyEarned: {
    height: 20,
    width: 50,
    alignSelf: 'flex-end',
  },
  loadingBoxLast: {
    height: indent,
    width: indent * 10,
    marginBottom: indent,
  },
});
